 <fadv-layout>
    <fadv-layout-main>
      <div class='main'>
        <app-alert-message></app-alert-message>
        <router-outlet></router-outlet>
      </div>
    </fadv-layout-main>
        <fadv-layout-section *ngIf="!hideStepper" position='left'>
            <div class='left'>
              <!-- <div class="showHideStepper"
              [ngStyle]="{'min-height': divSize}"
                style="padding: 20px; position: relative;"
                > -->
                <fadv-stepper #signUpStepper
                  [linear]="true"
                  [orientation]="this?.stepperPosition"
                  [selectedStep]="currentStep"
                  (stepActivated)="this?.stepActivatedCallBack($event)">

                      <!-- <fadv-step label="Start" #startStep  ></fadv-step>
                      <fadv-step label="Package" #packageStep ></fadv-step>
                      <fadv-step label="Candidate" #candidateStep  ></fadv-step>
                      <fadv-step label="Payment" #paymentStep></fadv-step>
                      <fadv-step label="Credentialing" #credentialingStep></fadv-step>
                      <fadv-step label="Account" #accountStep ></fadv-step> -->
                      <fadv-step label="Start"  #startStep     > <fadv-icon library="solid" name="star"></fadv-icon></fadv-step>
                      <fadv-step label="Package"    #packageStep   ><fadv-icon library="solid" name="cart-plus"></fadv-icon></fadv-step>
                      <fadv-step label="Applicant"   #candidateStep  ><fadv-icon library="solid" name="user"></fadv-icon></fadv-step>
                      <fadv-step label="Payment"   #paymentStep ><fadv-icon library="solid" name="credit-card"></fadv-icon></fadv-step>
                      <fadv-step label="Account"   #accountStep  ><fadv-icon library="solid" name="user"></fadv-icon></fadv-step>
                      <fadv-step label="Credentialing"   #credentialingStep  ><fadv-icon library="solid" name="flag-checkered"></fadv-icon></fadv-step>
                    <!--     <fadv-step label="Start"  (click)="gotoStep('/signup/start')" #startStep     > <fadv-icon library="solid" name="star"></fadv-icon></fadv-step>
                        <fadv-step label="Package" (click)="gotoStep('/signup/package')"   #packageStep   ><fadv-icon library="solid" name="cart-plus"></fadv-icon></fadv-step>
                        <fadv-step label="Candidate" (click)="gotoStep('/signup/candidate')"  #candidateStep  ><fadv-icon library="solid" name="user"></fadv-icon></fadv-step>
                        <fadv-step label="Payment" (click)="gotoStep('/signup/payment')"  #paymentStep ><fadv-icon library="solid" name="credit-card"></fadv-icon></fadv-step>
                       <fadv-step label="Account" (click)="gotoStep('/signup/account')"  #accountStep  ><fadv-icon library="solid" name="user"></fadv-icon></fadv-step>
                       <fadv-step label="Credentialing"   #credentialingStep  ><fadv-icon library="solid" name="flag-checkered"></fadv-icon></fadv-step> -->

                      </fadv-stepper>

                     <!--   <fadv-menu>
                        <fadv-menu-item routerLink="./start" [checked]="isComplete('start')" [disabled]="!isComplete('start')"  >Get Started</fadv-menu-item>
                        <fadv-menu-item routerLink="./package" [checked]="isComplete('package')" [disabled]="!isComplete('package')" >Package</fadv-menu-item>
                        <fadv-menu-item routerLink="./candidate" [checked]="isComplete('candidate')" [disabled]="!isComplete('candidate')" >Candidate</fadv-menu-item>
                        <fadv-menu-item routerLink="./payment" [checked]="isComplete('payment')" [disabled]="!isComplete('payment')" >Payment</fadv-menu-item>
                        <fadv-menu-item routerLink="./credentialing" [checked]="isComplete('credentialing')" [disabled]="!isComplete('credentialing')" >Credentialing</fadv-menu-item>
                        <fadv-menu-item routerLink="./account" [checked]="isComplete('account')" [disabled]="!isComplete('account')" >Account</fadv-menu-item>
                      </fadv-menu>-->
               </div>

                  </fadv-layout-section>
              </fadv-layout>


